import { render } from "./seat.vue?vue&type=template&id=ccb0469e&scoped=true"
import script from "./seat.vue?vue&type=script&lang=js"
export * from "./seat.vue?vue&type=script&lang=js"

import "./seat.vue?vue&type=style&index=0&id=ccb0469e&lang=css"
import "./seat.vue?vue&type=style&index=1&id=ccb0469e&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb0469e"]])

export default __exports__